/**
 * Handle hash-anchored links so same-page re-clicks always scroll.
 * React Router does not re-fire navigation when Link.to matches current URL,
 * which prevents ScrollToTop's useEffect from re-running. This helper is
 * attached to onClick on all in-page anchor links.
 *
 * Usage: <Link to="/#services" onClick={(e) => handleHashLink(e, "services", pathname)} />
 */
export const handleHashLink = (e, id, currentPathname, options = {}) => {
  if (currentPathname !== "/") return;
  const el = document.getElementById(id);
  if (!el) return;
  e.preventDefault();
  const scroll = () => el.scrollIntoView({ behavior: "smooth", block: "start" });
  if (options.defer) {
    // Wait for exit animations (e.g. mobile menu AnimatePresence) to finish
    // before scrolling so the document height is stable.
    setTimeout(scroll, 450);
  } else {
    scroll();
  }
};
